/* Analyse maison MBBB — parcours client (ce que Shopify ne montre pas).
   Compteurs 100 % anonymes : aucun identifiant, aucune donnée personnelle, et RIEN
   n'est envoyé tant que le client n'a pas accepté les témoins (bannière Loi 25).
   Envoi par petits lots (sendBeacon), agrégé par jour côté serveur. */
(function () {
  'use strict';
  var API = ((window.MBBTHEME || {}).apiUrl || '').replace(/\/+$/, '');
  if (!API) return;
  var buf = [];
  var timer = null;
  function consented() {
    try { return localStorage.getItem('mbb-consent') === 'yes'; } catch (e) { return false; }
  }
  function flush() {
    timer = null;
    if (!buf.length) return;
    if (!consented()) { buf = []; return; }
    var body = JSON.stringify({ events: buf.splice(0, 25) });
    try {
      // text/plain = requête « simple » : sendBeacon passe sans prévol même entre domaines
      if (navigator.sendBeacon) navigator.sendBeacon(API + '/api/events', new Blob([body], { type: 'text/plain' }));
      else fetch(API + '/api/events', { method: 'POST', headers: { 'Content-Type': 'text/plain' }, body: body, keepalive: true });
    } catch (e) {}
    if (buf.length) flush();
  }
  window.mbbTrack = function (name) {
    if (!consented()) return;
    buf.push({ n: String(name) });
    if (buf.length >= 25) flush();
    else if (!timer) timer = setTimeout(flush, 5000);
  };
  document.addEventListener('visibilitychange', function () { if (document.hidden) flush(); });
  window.addEventListener('pagehide', flush);

  // Vue de page par gabarit (le body porte template-xxx)
  var tpl = (document.body.className.match(/template-([a-z0-9-]+)/) || [])[1];
  if (tpl) window.mbbTrack('page:' + (tpl === 'index' ? 'accueil' : tpl));

  // Ajouts au panier + passage au paiement (délégué, ne casse rien)
  document.addEventListener('click', function (e) {
    var add = e.target.closest('.js-add');
    if (add) {
      if (add.closest('#cartUpsell')) window.mbbTrack('panier:upsell_ajout');
      else if (add.closest('#nudgeSuggest')) window.mbbTrack('nudge:upsell_ajout');
      else window.mbbTrack('panier:ajout');
      return;
    }
    if (e.target.closest('a[href="/checkout"], a[href^="/checkout?"]')) window.mbbTrack('paiement:clic');
  }, true);
  document.addEventListener('submit', function (e) {
    if (e.target.closest('form[data-mbb-ajax]')) window.mbbTrack('panier:ajout');
  }, true);
})();
